<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">EMAIL TEMPLATE</h1>
      <button class="create-button" @click="handleCreate()">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> CREATE</span>
      </button>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        :empty-text="$t('noData')"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link class="text-link" @click="onEdit(data.item.id)">
              <font-awesome-icon icon="pencil-alt" class="text-warning" title="Edit" />
            </b-link>
            <b-link class="text-link ml-3" @click="onDeleteModal(data.item)">
              <font-awesome-icon icon="trash-alt" class="text-danger" title="Delete" />
            </b-link>
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="
            form-inline
            justify-content-center justify-content-sm-between
          "
        >
          <div v-if="rows > 0" class="my-auto">
            Showing {{ startPage | numeral("0,0") }} to {{ endPage | numeral("0,0") }} of {{ rows | numeral("0,0") }} entires
          </div>
          <div v-else class="my-auto">{{ rows || 0 }} entire</div>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMsgDelete"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  name: "SettingEmail",
  components: {
    ModalAlertConfirm,
  },
  data: function() {
    return {
      modalMsgDelete: "",
      bodyDelete: {
        id: 0,
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      filter: {
        pageNo: 1,
        perPage: 10,
      },
      fields: [
        {
          key: "name",
          label: "Name",
          tdClass: "text-left",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      items: [],
      activeCopyId: false,
      disabledCopy: true
    };
  },

  created: async function() {
    await this.pagination(1);
  },
  methods: {
    getList: async function() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/Email/GetList`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.data;
            this.rows = data.detail.total;
          }
        });
      this.isBusy = false;
    },
    handleCreate() {
      this.$router.push({ path: `/email-template/create` }).catch(() => {});
    },
    onEdit(id) {
      this.$router.push({ path: `/email-template/${id}` }).catch(() => {});
    },  
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    onDeleteModal(data) {
      this.bodyDelete.id = data.id;
      this.modalMsgDelete = `${this.$t('confirmDelete2')} ${data.name} ${this.$t('yesOrNo')}`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(
          `${this.$baseUrl}/Email/Remove/${this.bodyDelete.id}`
        )
        .then(async (data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
            await this.pagination(1);
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });
    },
  },
};
</script>
